export default __webpack_public_path__ + "static/media/thomas.6c109390.jpg";